module.exports = __webpack_public_path__ + "static/media/5.ebb91e1f.svg";